import IconComponent from "@CubeComponents/icons";
import { useEffect } from "react";
import PropTypes from "prop-types";

const HelpSection = ({ isDragging = false, handleHelpSectionClick }) => {
  useEffect(() => {
    return () => {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, [0]);
    };
  }, []);

  return (
    <div className="bg-white h-full overflow-auto w-full shadow-[4px_4px_15px_0px_rgba(65,92,171,0.15)] rounded-md">
      <div className="bg-white absolute flex justify-end items-center end-2 pe-4 top-1 h-9 w-32 z-50">
        <IconComponent onClick={handleHelpSectionClick} name="close" />
      </div>
      <iframe
        title="helpSection"
        style={isDragging ? { pointerEvents: "none" } : {}}
        src="https://support.cube.ms/ebd/253de45767ab80f49c72d6992a5610e2?v=266de45767ab802ba907000cc6841787"
        width="100%"
        height="100%"
        allowfullscreen
      />
    </div>
  );
};
HelpSection.propTypes = {
  isDragging: PropTypes.bool,
  handleHelpSectionClick: PropTypes.func,
};
export default HelpSection;
